import api from "./Api";

// export const registerUser = (data) =>
//   api.post("/Auth/register", data);

export const sendOtp = (data) =>
  api.post("/Auth/send-otp", data);

export const verifyOtp = (data) =>
  api.post("/Auth/verify-otp", data);

export const loginUser = (data) =>
  api.post("/Auth/login", data);

export const sendForgotPasswordOtp = (data) =>
  api.post("/Auth/send-otp-forgot", data);

export const verifyForgotPasswordOtp = (data) =>
  api.post("/Auth/verify-otp-forgot", data);

export const resetPassword = (data) =>
  api.post("/Auth/reset-password", data);

export const getServices = (data) =>
  api.get("Service/getServices", data);